const __WEBPACK_NAMESPACE_OBJECT__ = vendor.wp.hooks;